import CheckCircle from '@mui/icons-material/CheckCircle'
import Error from '@mui/icons-material/Error'
import RemoveCircle from '@mui/icons-material/RemoveCircle'
import moment from 'moment'
import { CvsAvatar } from '@components'
import { ListType } from '@admin/template-elements/edit-list/types'
import { t } from '@lingui/core/macro'

export const getCellContent = (type, value) => {
  switch (type) {
    case 'list':
      return value.map(f => f.name).join(', ')
    case 'boolean':
      return typeof value !== 'undefined' ? (
        value ? (
          <CheckCircle fontSize="large" color="secondary" />
        ) : (
          <Error fontSize="large" color="error" />
        )
      ) : (
        <RemoveCircle fontSize="large" color="disabled" />
      )
    case 'avatar':
      return <CvsAvatar user={value} />
    case 'number':
      return Intl.NumberFormat().format(value)
    case 'date':
      return value ? moment(value).format('MM/DD/YY') : t`Never`
    case 'datetime':
      return moment(value).format('M/D/YY h:mm:ss a')
    case 'listType': {
      const listTypes = {
        [ListType.DrillDown]: t`Drill Down`,
        [ListType.DropDown]: t`Drop Down`,
        [ListType.Dependent]: t`Dependent`,
      }

      return listTypes[value]
    }
    case 'target':
      return value.map(targetField => `${targetField.target.name} > ${targetField.name}`).join(', ')
    default:
      return value
  }
}
